import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cutNumber',
  standalone: true,
})
export class CutNumberPipe implements PipeTransform {
  transform(value: number | string, digitsInfo: string = '1.2-2', locale: string = 'en-US'): string {
    if (value == null || value === '') {
      return '';
    }

    const num = Number(value);
    if (isNaN(num)) {
      return String(value);
    }

    const match = digitsInfo.match(/^(\d+)\.(\d+)-(\d+)$/);
    if (!match) {
      throw new Error(`Invalid digitsInfo format: ${digitsInfo}`);
    }

    const [, , minFractionStr, maxFractionStr] = match;
    const minFraction = parseInt(minFractionStr, 10);
    const maxFraction = parseInt(maxFractionStr, 10);

    const [intPart, fracPart = ''] = String(num).split('.');

    let trimmedFrac = fracPart.substring(0, maxFraction);
    while (trimmedFrac.length < minFraction) {
      trimmedFrac += '0';
    }

    const formatted = trimmedFrac.length > 0 ? `${intPart}.${trimmedFrac}` : intPart;

    const parts = formatted.split('.');
    const withSeparators = new Intl.NumberFormat(locale).format(Number(parts[0]));

    return parts.length > 1 ? `${withSeparators}.${parts[1]}` : withSeparators;
  }
}
